export const requiredFieldText = "This field is required";
export const searchMinLengthFieldText = "Value cannot be lower than 3";
export const minOneFieldText = "Value cannot be lower than 1";
export const minOneEmailText = "Email column is required";
export const minZeroFieldText = "Value cannot be lower than 0";
export const atLeastOneOption = "At least one option is required";

export const searchMinLength = 3;
